<div class="d-flex order-templates" data-testing-id="order-template-product">
  <div class="col-4 pr-0 col-md-2 list-item">
    <div class="d-flex align-items-center">
      <div class="check-box-input-color">
        <input
          #checkBoxInput
          type="checkbox"
          data-testing-id="productCheckbox"
          [formControl]="checkBox"
          aria-label="Select item to add to cart"
          (change)="emitCheckboxEvent.emit(checkBoxInput.checked)"
        />
      </div>
      <div class="d-md-inline">
        <ish-product-image imageType="M" [link]="true"></ish-product-image>
      </div>
    </div>
  </div>
  <div class="col-8 col-md-6 list-item d-block d-md-flex">
    <div class="col-12 col-md-9 pli-description">
      <ish-product-name></ish-product-name>
      <ish-product-id></ish-product-id>
      <ish-product-variation-display></ish-product-variation-display>
      <ish-product-bundle-display></ish-product-bundle-display>
      <ish-product-inventory></ish-product-inventory>

      <div *ngIf="currentOrderTemplate.editable">
        <a
          [routerLink]="[]"
          class="btn-tool"
          [title]="'account.order_template.table.options.move_to_template' | translate"
          (click)="moveDialog.show()"
          data-testing-id="move-order-template"
        >
          <fa-icon [icon]="['fas', 'arrows-alt']" />
        </a>
        <a
          [routerLink]="[]"
          class="btn-tool"
          [title]="'modal.heading.remove.order.template' | translate"
          (click)="removeProductFromOrderTemplate(orderTemplateItemData.sku)"
          data-testing-id="delete-order-template"
        >
          <fa-icon [icon]="['fas', 'trash-alt']" />
        </a>
      </div>
    </div>
    <div class="col-6 col-md-3 p-md-0 text-right">
      <ish-product-quantity></ish-product-quantity>
    </div>
    <div class="col-6 d-md-none">
      <ish-product-price></ish-product-price>
    </div>
  </div>
  <div class="col-2 list-item d-none d-md-block text-right">
    {{ orderTemplateItemData?.creationDate | ishDate : 'shortDate' }}
  </div>
  <div class="col-4 col-md-2 list-item column-price d-none d-md-block">
    <ish-product-price></ish-product-price>
  </div>
</div>

<ish-select-order-template-modal
  #moveDialog
  addMoveProduct="move"
  (submitEmitter)="moveItemToOtherOrderTemplate(orderTemplateItemData.sku, $event)"
></ish-select-order-template-modal>
